var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailQuestion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 13,
    viewBox: "0 0 17 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.72656 1.97705C2.45156 1.97705 2.22656 2.20205 2.22656 2.47705V3.16768L7.61719 7.59268C8.26406 8.12393 9.19219 8.12393 9.83906 7.59268L15.2266 3.16768V2.47705C15.2266 2.20205 15.0016 1.97705 14.7266 1.97705H2.72656ZM2.22656 5.1083V10.4771C2.22656 10.7521 2.45156 10.9771 2.72656 10.9771H14.7266C15.0016 10.9771 15.2266 10.7521 15.2266 10.4771V5.1083L10.7891 8.75205C9.58906 9.73643 7.86094 9.73643 6.66406 8.75205L2.22656 5.1083ZM0.726562 2.47705C0.726562 1.37393 1.62344 0.477051 2.72656 0.477051H14.7266C15.8297 0.477051 16.7266 1.37393 16.7266 2.47705V10.4771C16.7266 11.5802 15.8297 12.4771 14.7266 12.4771H2.72656C1.62344 12.4771 0.726562 11.5802 0.726562 10.4771V2.47705Z",
    fill: "#0E7490"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailQuestion);
export default __webpack_public_path__ + "static/media/email-question.c9cd8576cc5afb3404cc6c560aaba55e.svg";
export { ForwardRef as ReactComponent };